export class OptionListError extends Error {
    constructor(message) {
        super(message);
        this.name = 'OptionListError';
    }
}
//# sourceMappingURL=types.js.map